import { createContext } from 'react';

/**
 * FRONT-3223: true on a surface whose open questions are answered from the
 * reply box (`chat-question-dock.tsx`). The conversation's `QuestionsCard` is
 * then a record: one collapsed line per batch that opens to the questions, as
 * the Builder's (eddy, 2026-10-28), never a second place to answer. Its own module so the card and the dock do not
 * import each other.
 */
export const ChatQuestionsDockedContext = createContext(false);
